import { defineComponent as v, computed as f, createBlock as i, openBlock as l, unref as r, mergeProps as B, createSlots as C, withCtx as s, createElementVNode as b, createElementBlock as N, createCommentVNode as m, renderSlot as u, Fragment as O, createVNode as d, resolveDynamicComponent as z } from "vue";
import E from "./highrise411.mjs";
import H from "./highrise334.mjs";
import F from "./highrise352.mjs";
import p from "./highrise353.mjs";
import L from "./highrise386.mjs";
import I from "./highrise415.mjs";
import { JSONtoNaiveVars as M } from "./highrise343.mjs";
import D from "./highrise355.mjs";
import "./highrise34.mjs";
import "./highrise59.mjs";
import S from "./highrise474.mjs";
import { modalThemeOverrides as A, modalStyleOverrides as T } from "./highrise475.mjs";
import "./highrise15.mjs";
import "./highrise27.mjs";
import { COMPONENT_NAME as V } from "./highrise178.mjs";
import P from "./highrise476.mjs";
import h from "./highrise84.mjs";
import R from "./highrise139.mjs";
import J from "./highrise159.mjs";
import k from "./highrise125.mjs";
const U = { class: "hr-dialog__content--text" }, j = v({
  name: V.MODAL
}), fe = /* @__PURE__ */ v({
  ...j,
  props: {
    id: {},
    autoFocus: { type: Boolean, default: !1 },
    className: { default: void 0 },
    closeOnEsc: { type: Boolean, default: !0 },
    maskClosable: { type: Boolean, default: !0 },
    show: { type: Boolean, default: !1 },
    showBack: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderIcon: { type: Boolean, default: !0 },
    to: { default: void 0 },
    type: { default: "default" },
    width: { default: 483 },
    zIndex: { default: void 0 },
    footerDivider: { type: Boolean }
  },
  emits: ["after-enter", "after-leave", "back", "before-leave", "close", "esc", "left-click", "mask-click", "right-primary-click", "right-secondary-click", "update:show"],
  setup(y) {
    const t = y, c = {
      default: p,
      error: L,
      info: p,
      success: F,
      warning: E
    }, $ = f(() => A(t)), w = f(() => M(T(t))), n = f(() => t.type), g = f(() => ({
      "hr-modal": !0,
      "hr-modal--auto-focus": t.autoFocus,
      "hr-modal--close-on-esc": t.closeOnEsc,
      "hr-modal--mask-closable": t.maskClosable,
      "hr-modal--show-back": t.showBack,
      "hr-modal--show-close": t.showClose,
      "hr-modal--show-footer": t.showFooter,
      "hr-modal--show-header": t.showHeader,
      "hr-modal--show-header-icon": t.showHeaderIcon,
      [`hr-modal--${t.to}`]: t.to,
      [`hr-modal--${n.value}`]: n.value,
      className: t.className
    }));
    return (e, o) => (l(), i(r(P), B({
      id: e.id,
      preset: "dialog",
      "auto-focus": e.autoFocus,
      class: g.value,
      "close-on-esc": e.closeOnEsc,
      "mask-closable": e.maskClosable,
      show: e.show,
      style: w.value,
      "theme-overrides": $.value,
      to: e.to,
      "z-index": e.zIndex
    }, e.$attrs, {
      onAfterEnter: o[5] || (o[5] = () => e.$emit("after-enter")),
      onAfterLeave: o[6] || (o[6] = () => e.$emit("after-leave")),
      onBeforeLeave: o[7] || (o[7] = () => e.$emit("before-leave")),
      onClose: o[8] || (o[8] = () => e.$emit("close")),
      onEsc: o[9] || (o[9] = () => e.$emit("esc")),
      onMaskClick: o[10] || (o[10] = (a) => e.$emit("mask-click", a)),
      "onUpdate:show": o[11] || (o[11] = (a) => e.$emit("update:show", a))
    }), C({
      default: s(() => [
        b("div", U, [
          e.$slots.default ? (l(), i(r(h), {
            key: 0,
            size: "md",
            weight: "regular",
            class: "hr-modal__content"
          }, {
            default: s(() => [
              u(e.$slots, "default")
            ]),
            _: 3
          })) : m("", !0)
        ]),
        e.showFooter ? (l(), N(O, { key: 0 }, [
          e.footerDivider ? (l(), i(r(R), {
            key: 0,
            "title-placement": "right",
            "margin-bottom": !1,
            "margin-top": !1
          })) : m("", !0),
          e.$slots.footer ? u(e.$slots, "footer", { key: 1 }) : (l(), i(S, {
            key: 2,
            type: n.value,
            onLeftClick: o[2] || (o[2] = (a) => e.$emit("left-click")),
            onRightSecondaryClick: o[3] || (o[3] = (a) => e.$emit("right-secondary-click")),
            onRightPrimaryClick: o[4] || (o[4] = (a) => e.$emit("right-primary-click"))
          }, null, 8, ["type"]))
        ], 64)) : m("", !0)
      ]),
      _: 2
    }, [
      e.showClose ? {
        name: "close",
        fn: s(() => [
          d(r(J), {
            id: "hr-modal__close-button",
            variant: "text",
            size: "xs",
            class: "hr-modal__close-button",
            onClick: o[0] || (o[0] = () => {
              e.$emit("update:show", !1), e.$emit("close");
            })
          }, {
            default: s(() => [
              d(r(k), { size: "20" }, {
                default: s(() => [
                  d(r(I))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        key: "0"
      } : void 0,
      e.$slots.header && e.showHeader ? {
        name: "header",
        fn: s(() => [
          e.showBack ? (l(), i(r(k), {
            key: 0,
            size: "18",
            class: "cursor-pointer mr-2",
            onClick: o[1] || (o[1] = (a) => e.$emit("back"))
          }, {
            default: s(() => [
              d(r(H))
            ]),
            _: 1
          })) : m("", !0),
          e.showHeaderIcon ? (l(), i(D, {
            key: 1,
            size: "sm",
            color: "var(--n-dialog-icon-stroke)",
            "bg-color": "var(--n-dialog-icon-bg-color)"
          }, {
            default: s(() => [
              (l(), i(z(c[n.value])))
            ]),
            _: 1
          })) : m("", !0),
          d(r(h), {
            size: "2xl",
            weight: "semibold",
            "html-tag": "div",
            class: "hr-modal__header-title"
          }, {
            default: s(() => [
              u(e.$slots, "header")
            ]),
            _: 3
          })
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["id", "auto-focus", "class", "close-on-esc", "mask-closable", "show", "style", "theme-overrides", "to", "z-index"]));
  }
});
export {
  fe as default
};
